import queryString from 'query-string';
import Auth from 'api/Auth';
import { useEffect, useRef } from 'react';
import { handleSSO, oauthCallback } from 'store/actions/authActions';
import { parseJwt } from 'utils';
import axios from 'config/axios';
import { studentAppLink } from 'utils';
import { resolveSisSchool } from 'utils/sisSchoolAuth';
import { safeReturnPath, startLsgoAuthenticationLogin } from 'utils/lsgoAuthenticationRedirectFlow';

const SentralLogin = (props) => {
    const params = queryString.parse(new URL(window.location.href).search);
    const schoolCode = params?.school_code;
    const authStarted = useRef(false);
    console.log('SENTRAL LOGIN', params);

    useEffect(() => {
        console.log(params, 'paramssss');
        if (params?.code && params?.state) {
            sso();
        } else {
            getSentralSchoolEndpoint();
        }
    }, [params]);

    //comment

    function getStringBetween(str, start, end) {
        // const result = str.match(new RegExp(start + '(.*)' + end));
        const params = str?.split(start)[1];
        const result = params?.split(end)[0];

        return result;
    }

    function getURI(str) {
        return str.split('_')[1];
    }

    const sso = async () => {
        if (params?.code && params?.state) {
            const oauthCallbackResponse = await oauthCallback({
                ...params,
                // redirectUri: `${studentAppLink}${window.location.pathname}?auth_method=sentral_sso`,
            });
            // Legacy refused: the school is on lsgo-authentication and sign-in has started there.
            if (oauthCallbackResponse?.authManaged) return;

            await Auth.userV2({
                redirect: true,
                history: props.history,
                redirectUri: params.redirectUri,
            }).then(async (token) => {
                console.log(token, 'token');
                if (typeof token === 'string') {
                    const decoded = await parseJwt(token.replace('Bearer ', ''));
                    if (decoded.id) {
                        try {
                            console.log(decoded, 'decoded');
                            // const profile = await Teachers.getUserProfile(decoded.id);
                            // if (!profile.data.name) profile.data.name = profile.data.firstName;
                            // store.dispatch(setCurrentTeacher({ ...profile.data, alias: decoded.alias }));
                        } catch (error) {
                            console.log(error, 'error');
                        }
                    }
                }
            });
        }
    };

    const getSentralSchoolEndpoint = async () => {
        if (schoolCode) {
            // Schools on lsgo-authentication sign in there, straight through Sentral.
            const { tenant, useLsgoAuth } = await resolveSisSchool(schoolCode);
            if (useLsgoAuth) {
                if (authStarted.current) return;
                authStarted.current = true;
                await startLsgoAuthenticationLogin(safeReturnPath(params.redirectUri), { idp: 'sentral', tenant });
                return;
            }

            const sentralSchoolEndpoint = await axios.get(
                `/api/v4/schools/sis/sso/endpoint/${schoolCode}?student=true`
            );
            if (sentralSchoolEndpoint?.data?.endpoint) {
                const {
                    data: { state, redirectUri },
                } = await axios.post('/api/v6/auth/oauth/start', {
                    // https%3A%2F%2Fteacher.lifeskillsgo.com%2F%3FredirectUri%3D%252Fsentral%252Fschool%253FschoolId%253D66666_6
                    redirectUri: `${studentAppLink}${
                        window.location.pathname
                    }?auth_method=sentral_sso&redirectUri=${encodeURIComponent(params.redirectUri)}`,
                    email: '',
                    metadata: {},
                    provider: sentralSchoolEndpoint?.data?.provider?.id,
                });
                console.log(redirectUri, 'redirectUri', JSON.stringify(sentralSchoolEndpoint.data), state, redirectUri);
                window.open(
                    `${sentralSchoolEndpoint.data.endpoint}?client_id=LifeskillsGroup&redirect_uri=${encodeURIComponent(
                        redirectUri
                    )}&response_type=code&state=${state}`, // https%3A%2F%2Fteacher.lifeskillsgo.com%2F%3FredirectUri%3D%252Fsentral%252Fschool%253FschoolId%253D66666_6
                    '_self'
                );
            } else if (sentralSchoolEndpoint?.data?.status === 'inactive_trial') {
                params?.state?.includes('schoolBytes')
                    ? props.history.push('/schoolBytes-inactive')
                    : props.history.push('/sentral-inactive');
            }
        }
    };

    return <div></div>;
};

export default SentralLogin;
